import strings from 'utils/strings';

export default function getAgeLabel(age) {
	if (age) {
		if (age.months) {
			return strings.formatString(strings.common.arOch, age.years, age.months);
		}
		return strings.formatString(strings.common.arEnbart, age.years);
	}

	return null;
}
